<template>
  <tr>
    <GroupCell
      v-model="group"
      class="group-background"
      :is-loading="false"
      @Remove="remove"
      @Copy="copy"
    />
    <SelectorCell
      v-for="(selector, selctorIndex) in group.selectors"
      :key="selctorIndex"
      v-model="group.selectors[selctorIndex]"
      :is-loading="false"
    />
    <td class="height-cell" />
  </tr>
</template>

<script>
import GroupCell from '@/employees/components/PreferenceConfig/Group/GroupCell'
import SelectorCell from '@/employees/components/PreferenceConfig/Selector/SelectorCell'
export default {
  name: 'GroupRow',
  components: {
    GroupCell,
    SelectorCell,
  },
  props: {
    value: {
      required: true,
      type: Object,
    },
    index: {
      required: true,
      type: Number,
    },
    weightList: {
      required: true,
      type: Array,
    },
  },
  computed: {
    group: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  watch: {
    weightList: {
      handler () {
        this.group.selectors = this.currentSelectors()
      },
    },
  },
  created () {
    this.group.selectors = this.currentSelectors()
    this.$root.$on('UpdateWeight', this.updateSelector)
  },
  destroyed () {
    this.$root.$off('UpdateWeight', this.updateSelector)
  },
  methods: {
    copy (group) {
      this.$emit('Copy', group)
    },
    remove () {
      this.$store.dispatch('delete_group', { name: this.value.name, term: this.value.term })
      this.$emit('Remove', this.index)
    },
    updateSelector ({ oldWeight, newWeight }) {
      this.group.selectors = this.group.selectors
        .map(selector => {
          if (selector.weight !== oldWeight) {
            return selector
          }
          selector.weight = newWeight
          return selector
        })
    },
    currentSelectors () {
      const selectors = []
      for (let i = 0, length = this.weightList.length; i < length; i++) {
        selectors.push(this.findSelectorBasedOnWeight(this.weightList[i], this.group.selectors))
      }
      return selectors
    },
    findSelectorBasedOnWeight (weight, selectors) {
      const selector = selectors.find(selector => selector.weight === weight)
      if (selector) {
        selector.weight = weight
        return selector
      } else {
        return {
          weight,
          selector: null,
        }
      }
    },
  },
}
</script>

<style scoped>
tr td:last-child {
  border-left: none;
  border-right: none;
  border-bottom: none;
}
</style>
